import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { RestSchemas } from '@/contexts/QueryProvider'
import { useSessionStorage } from '@/hooks/useSessionStorage'
import { useRestClient } from '@/contexts/QueryProvider'
import { isPlatformAdmin, isSuperUser } from '@/util'
import { toast } from 'sonner'
import { useCurrentWorkspace } from '../../useCurrentWorkspace'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'

type MessagesWorkspacesEntity = RestSchemas['Messages.Workspaces.Entity']

export function RowActionsMenu({ entity }: { entity: MessagesWorkspacesEntity }) {
  const { workspaceId } = useCurrentWorkspace()
  const [userRole] = useSessionStorage('roles', 1)

  const isDeleteEntityAllowed = isPlatformAdmin(userRole) || isSuperUser(userRole)

  const isFreezeEntityAllowed = isPlatformAdmin(userRole) || isSuperUser(userRole)

  const restClient = useRestClient()

  const {
    deleteWorkspacesApiDeleteEntity,
    postWorkspacesApiFreezeEntity,
    getWorkspacesApiGetOrganisationWorkspaceEntities,
  } = restClient

  const entityId = Number(entity.entityId)

  const { mutate: deleteEntity } = deleteWorkspacesApiDeleteEntity.useMutation(
    { query: { entityId } },
    {
      onSuccess: () => {
        getWorkspacesApiGetOrganisationWorkspaceEntities.invalidateQueries({ parameters: { query: { workspaceId } } })
      },
      onError: (error) => {
        console.error('Delete failed:', error)
        toast.error('Failed to delete entity')
      },
    }
  )

  const { mutate: freezeEntity } = postWorkspacesApiFreezeEntity.useMutation(
    { query: { entityId } },
    {
      onSuccess: () => {
        getWorkspacesApiGetOrganisationWorkspaceEntities.invalidateQueries({ parameters: { query: { workspaceId } } })
      },
      onError: (error) => {
        console.error('Freeze failed:', error)
        toast.error('Failed to freeze entity')
      },
    }
  )

  return (
    <>
      <DropdownMenu
        onOpenChange={(open) => {
          // This is necessary to maintain the open state when we want to keep it open
          if (!open) {
            // Check if we need to prevent closing
            // This is a placeholder for custom logic you might need
            // We'll use other mechanisms to prevent closing on item click
          }
        }}
      >
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" className="size-8 rounded-full">
            <IconMenuOutline size={16} />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          onCloseAutoFocus={(e) => {
            // Prevent focus returning to trigger which can close the menu
            e.preventDefault()
          }}
        >
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <ConfirmDialog
            trigger={
              <DropdownMenuItem onSelect={(e) => e.preventDefault()} disabled={!isFreezeEntityAllowed}>
                Freeze entity
              </DropdownMenuItem>
            }
            title="Freeze entity"
            description="Please confirm that the entity should be frozen?"
            onConfirm={() => freezeEntity()}
          />
          <ConfirmDialog
            trigger={
              <DropdownMenuItem onSelect={(e) => e.preventDefault()} disabled={!isDeleteEntityAllowed}>
                Delete entity
              </DropdownMenuItem>
            }
            title="Delete entity"
            description="Please confirm that the entity should be deleted?"
            onConfirm={() => deleteEntity()}
          />
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
